<template>
	<div class="device-filter">

		<div class="item1">
			<slot name="title">
				<span class="device-filter__title">I'm Using : </span>
			</slot>
		</div>

		<div class="item2">
			<v-btn icon class=" "
				:class="(selectedPlatforms & 8) === 0 ? 'button--secondary' : 'button--primary'" :width="39" :height="39"
				@click="selectPlatform(8)">
				<v-icon>
					<windows-icon :color="getColor(8)" />
				</v-icon>
			</v-btn>
		</div>

		<div class="item4">
			<v-btn icon class=" "
				:class="(selectedPlatforms & 6) === 0 ? 'button--secondary' : 'button--primary'" :width="39" :height="39"
				@click="selectPlatform(6)">
				<v-icon>
					<apple-white-icon :color="getColor(4)" />
				</v-icon>
			</v-btn>
		</div>

		<div class="item5">
			<v-btn icon class=" "
				:class="(selectedPlatforms & 1) === 0 ? 'button--secondary' : 'button--primary'" :width="39" :height="39"
				@click="selectPlatform(1)">
				<v-icon>
					<android-icon :color="getColor(1)" />
				</v-icon>
			</v-btn>
		</div>

	</div>
</template>



<script lang="ts" setup>

import { ref } from 'vue';
import { useAppConfigStore } from "@/store/AppConfigStore";

import WindowsIcon from "@/icons/WindowsGrey.vue";
import AndroidIcon from "@/icons/AndroidGrey.vue";
import AppleWhiteIcon from "@/icons/AppleWhite.vue";

const appConfigStore = useAppConfigStore();
const iconSelectedColor = 'white';
const iconDefaultColor = '#6D7492';

const selectedPlatforms = ref(appConfigStore.platforms);

const selectPlatform = (platform: number) => {
	if (((selectedPlatforms.value ?? 1) ^ platform) > 0) {
		selectedPlatforms.value = (selectedPlatforms.value ?? 1) ^ platform;
	}
	appConfigStore.platforms = selectedPlatforms.value;
}

const getColor = (platform: number) => {
	return (selectedPlatforms.value ?? 1) & platform ? iconSelectedColor : iconDefaultColor;
}

</script>



<style scoped lang="scss">

.device-filter {
	display: grid;
	grid-template-rows: 40px;
	grid-template-columns: 20px 20px 20px 20px 20px 22px 22px 22px 22px 22px 22px 22px 22px;

	&__title {
		font-size: 18px;
		font-weight: 600;
		white-space: nowrap;
	}
}

.item1 {
	grid-row: span 1;
	grid-column: span 5;
	align-self: center;
}

.item2 {
	grid-row: span 1;
	grid-column: span 2;
	align-self: center;
}

.item3 {
	grid-row: span 1;
	grid-column: span 2;
	align-self: center;
}

.item4 {
	grid-row: span 1;
	grid-column: span 2;
	align-self: center;
}

.item5 {
	grid-row: span 1;
	grid-column: span 2;
	align-self: center;
}

@media only screen and (max-width: 599px) {
	.vertical-upto-sm {
		display: grid;
		grid-template-rows: 20px 40px;
		grid-template-columns: 20px 20px 20px 20px 20px 20px 20px 20px;
		grid-gap: 8px 2px;

		.item1 {
			grid-row: span 1;
			grid-column: span 9;
		}
	}

}

</style>